import { IBannerDetailsMediaComponent } from "../banner-details-media.component";

export class StaticImageComponent implements IBannerDetailsMediaComponent {
    private _currentContext: JQuery = $();

    public init(context: JQuery<HTMLElement>): void {
        this._currentContext = context || this._currentContext;
    }

    public dispose(): void {
        this._currentContext.html(null);
    }
}
